// Charge la base commune
import './common.js'

// Offers Alert Form
async function getOaForm ($f) {
  $f.load()
  import(/* webpackChunkName: "offersAlertForm" */ './js/components/offersAlertForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // formulaire d'inscription aux alertes terrains/offres
  const $c1 = $('form[name="oaForm"]')
  if ($c1.length) {
    $c1.waypoint(function () {
      getOaForm($c1)
      this.destroy()
    }, {
      offset: '100%'
    })
  }
})
